/* ============================================================
   Offe: never end a collection page on a half-empty row while
   there are more products to load.

   The grid's column count changes with the screen width and the
   2-up / 4-up view toggle (1 to 6 columns), and a promo tile takes
   two cells, so no single page size always fills the last row.
   While a "Load more" button (or infinite scroll) still has pages
   to fetch, the products in an unfinished last row are held back
   (hidden). When the next page loads they reappear in their place,
   ahead of the new products, so nothing is skipped or reordered.
   On the last page everything shows, so a collection that simply
   runs out of products can still end on a part row.

   Only acts with Load more / infinite scroll. With numbered pages
   hiding products would skip them, so it does nothing there.
   Loaded by the grid_fill custom-liquid section in templates/collection.json.
   ============================================================ */
(function () {
  var HOLD = 'offe-row-hold';
  var scheduled = false;

  function hasMorePages() {
    var cur = document.querySelector('[data-current-page]');
    var total = document.querySelector('[data-total-pages]');
    if (!cur || !total) return false;
    var c = parseInt(cur.value, 10);
    var t = parseInt(total.value, 10);
    if (isNaN(c) || isNaN(t)) return false;
    if (c >= t) return false;
    return !!document.querySelector('.js-load-more, .js-infinite-scroll');
  }

  function fill() {
    scheduled = false;
    var grid = document.getElementById('product-grid');
    if (!grid || !grid.classList.contains('load-more-grid')) return;

    var items = Array.prototype.filter.call(grid.children, function (el) {
      return el.classList.contains('collection-product-card');
    });
    items.forEach(function (el) { el.classList.remove(HOLD); });
    if (!items.length || !hasMorePages()) return;

    var cols = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length;
    if (cols < 2) return;

    var last = items[items.length - 1];
    var lastTop = last.offsetTop;
    // the right edge of a full row = the furthest-right edge of any card
    var rowRight = 0;
    items.forEach(function (el) {
      var r = el.getBoundingClientRect().right;
      if (r > rowRight) rowRight = r;
    });
    var lastRight = last.getBoundingClientRect().right;
    if (rowRight - lastRight < 2) return; // last row is already full

    var row = items.filter(function (el) { return el.offsetTop === lastTop; });
    if (row.length === items.length) return; // never hide the only row
    row.forEach(function (el) { el.classList.add(HOLD); });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(fill);
  }

  function init() {
    var container = document.getElementById('ProductGridContainer') || document.body;
    // grid re-rendered by filters/sorting, or a page appended by Load more
    new MutationObserver(schedule).observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-catalog-card-size']
    });
    window.addEventListener('resize', schedule);
    schedule();
  }

  var style = document.createElement('style');
  style.textContent = '#product-grid > .' + HOLD + '{display:none !important;}';
  document.head.appendChild(style);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
